import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";


const RemarksHistoryTable = ({ historyData = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (historyData?.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 3 }}>
        <p>No remarks history available</p>
      </Box>
    );
  }

  // Mobile view - card layout
  if (isMobile) {
    return (
      <Box sx={{ maxHeight: "400px", overflow: "auto", px: 1 }}>
        {historyData?.map((record, index) => (
          <Box 
            key={index} 
            sx={{ 
              mb: 2, 
              p: 2, 
              border: "1px solid #e0e0e0", 
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Box sx={{ fontWeight: "bold" }}>Staff ID: {record?.addedBy || "N/A"}</Box>
            </Box>
            <Box sx={{ fontSize: "0.85rem", color: "#666", mb: 1 }}>
              {record?.created_at ? formatDate(new Date(record?.created_at)) : "N/A"}
            </Box>
            <Box sx={{ mt: 1, wordBreak: "break-word" }}>
              {formatRemarks(record?.remarks, isMobile)}
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  // Desktop view - table layout
  return (
    <Box sx={{ maxHeight: "400px", overflow: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
            <th style={{ padding: "12px 8px", textAlign: "left" }}>Staff ID</th>
            <th style={{ padding: "12px 8px", textAlign: "left" }}>Date & Time</th>
            <th style={{ padding: "12px 8px", textAlign: "left" }}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {historyData?.map((record, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "12px 8px" }}>
                {record?.addedBy || "N/A"}
              </td>
              <td style={{ padding: "12px 8px" }}>
                {record?.created_at ? formatDate(new Date(record?.created_at)) : "N/A"}
              </td>
              <td style={{ padding: "12px 8px", maxWidth: "300px", wordBreak: "break-word" }}>
                {formatRemarks(record?.remarks, false)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

// Format date to dd/mm/yy : IST format
const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} : ${hours}:${minutes} IST`;
};

// Format remarks with bullet points and character limit
const formatRemarks = (remarks, isMobile) => {
  if (!remarks) return "N/A";
  
  // Split by newlines or periods to create bullet points
  const points = remarks.split(/[.\n]+/).filter(point => point.trim().length > 0);
  
  // For mobile view, use a simpler format with more space
  if (isMobile) {
    return (
      <div>
        {points.map((point, index) => {
          const trimmedPoint = point.trim();
            
          return trimmedPoint ? (
            <div key={index} style={{ marginBottom: "8px" }}>
              • {trimmedPoint}
            </div>
          ) : null;
        })}
      </div>
    );
  }
  
  // Desktop view with bullet points
  return (
    <ul style={{ margin: 0, paddingLeft: "20px" }}>
      {points.map((point, index) => {
        const trimmedPoint = point.trim();
          
        return trimmedPoint ? <li key={index}>{trimmedPoint}</li> : null;
      })}
    </ul>
  );
};

export default RemarksHistoryTable;